<template>
  <CModal :show.sync="show" centered>
    <template #header>
      <div>
        <div class="d-flex">
          <template v-if="numFilesDiscarded > 0">
            <div class="align-self-center">
                <CIcon name="cipAlertTriangle" size="custom-size" width="36" height="36"
                   class="mr-3 icon-circle icon-circle--warning"/>
            </div>

            <div class="align-self-center">
              <h5 class="modal-title" v-translate translate-context="globalUploader.receiver.modal.title">Photo upload limit reached</h5>
            <div style="color:#4E4D64;line-height:1.3" class="mr-1">
                <translate translate-context="globalUploader.uploading" :translate-params="{uploadLimit: uploadLimit, numFilesDiscarded: numFilesDiscarded}">
            You have exceeded the maximum limit of %{uploadLimit} uploadable photos: %{numFilesDiscarded} files will not be uploaded</translate>
              </div>
            </div>
          </template>
          <template v-else>
            <CIcon name="cipUpload2" size="custom-size" width="36" height="36"
                   class="mr-3 icon-circle icon-circle--primary"/>
            <div class="align-self-center">
              <h5 class="modal-title" v-translate translate-context="globalUploader.receiver.modal.title">Upload
                files</h5>
            </div>
          </template>
        </div>
      </div>
      <div>
        <CButtonClose @click="show = false"/>
      </div>
    </template>

    <template v-if="loading">
      Analyzing files...
    </template>
    <template v-else>
      <div v-if="numFiles > 0" class="mb-3">
        <template v-if="numFilesRaw > numFiles">
          <translate translate-context="globalUploader.uploading" :translate-params="{numFiles: numFiles, totalSize: totalSizeHuman, numFilesRaw: numFilesRaw}">
           You are about to upload %{numFiles} of %{numFilesRaw} files for a total of %{totalSize}.</translate>
        </template>
        <template v-else>
         <translate translate-context="globalUploader.uploading" :translate-params="{numFiles: numFiles, totalSize: totalSizeHuman}">
           You are about to upload %{numFiles} files for a total of %{totalSize}.</translate>
        </template>
      </div>
      <UploadErrors :files="errors"/>
    </template>
    <template #footer>
      <div class="d-flex justify-content-between" :class="{'w-100': numFilesDiscarded > 0}">
        <div v-if="numFilesDiscarded > 0">
          <div v-translate translate-context="globalUploader.uploading">Do you want a customized solution?</div>
          <div><a href="mailto:support@getpica.com" class="font-weight-semi-bold">
            <span v-translate translate-context="globalUploader.uploading">Contact us</span>
            <CIcon class="ml-1" name="cipArrowNarrowRight" /></a></div>
        </div>
        <div>
          <CButton class="mr-2" color="secondary" @click="show = false" v-translate>Cancel</CButton>
          <PButton
              v-if="numFiles > 0"
              color="primary"
              :disabled="loading"
              v-translate
              @click="startSession">
            Upload
          </PButton>
        </div>
      </div>

    </template>
  </CModal>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PButton from "@/components/PButton.vue";
import UploadErrors from "@/domain/uploader/components/UploadErrors.vue";

export default {
  name: 'UploadReceiver',
  components: {UploadErrors, PButton},
  data() {
    return {
      files: [],
      show: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters('uploader', [
      'eventStats',
    ]),
    totalSize() {
      return this.files.reduce((acc, file) => acc + file.size, 0)
    },
    totalSizeHuman() {
      return this.$options.filters.formatSize(this.totalSize)
    },
    numFiles() {
      return this.files.filter(file => !file.error).length
    },
    numFilesDiscarded() {
      return this.files.filter(file => file.error === 'uploadLimit').length
    },
    numFilesRaw() {
      return this.files.length
    },
    errors() {
      return this.files.filter(file => file.error)
    },
    uploadLimit() {
      return this.eventStats.upload_limit
    }
  },
  methods: {
    ...mapActions('uploader', [
      'validateFiles',
      'createSession'
    ]),
    async onFileDrop(files) {
      this.show = true
      this.loading = true
      this.files = []
      this.files = await this.validateFiles(files)
      this.loading = false
    },
    async startSession() {
      try {
        await this.createSession(this.files.filter(file => !file.error))
      } catch (e) {
        if (e.data.code === 'upload_limit_exceeded') {
          await this.notifyError(this.$pgettext('globalUploader.receiver.modal.upload_limit_exceeded', 'Upload limit exceeded'))
          this.show = false
          return
        }
        throw e
      }
      this.show = false
    }
  },
}
</script>